import { OSTYPE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: OSTYPE_MNG,
  params: null,
  formatData(data) {
    return data
  },
  view: {
    title: '创建操作系统',
    labelPosition: 'right',
    content: [
      {
        $id: 'osType',
        $type: 'input',
        label: '操作系统',
        $el: {
          placeholder: '请输入操作系统',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '操作系统'
          }
        ]
      },
      {
        $id: 'osTypeConfigList',
        $type: 'sky-os-type-config-relate',
        label: '支持的配置'
      }
    ]
  }
}
